var _defs, _use, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageLoadingBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message_loading_blue_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "message_loading_blue_svg__a",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "message_loading_blue_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#message_loading_blue_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.271,
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "message_loading_blue_svg__c",
    clipPath: "url(#message_loading_blue_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.602 8A5.601 5.601 0 102.399 8a5.601 5.601 0 0011.203 0zm0 0",
    fill: "none",
    strokeWidth: 1.6,
    stroke: "#4c6aff"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#message_loading_blue_svg__c",
    mask: "url(#message_loading_blue_svg__d)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.398A5.601 5.601 0 002.398 8",
    fill: "none",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    stroke: "#4c6aff"
  })));
}
export default __webpack_public_path__ + "static/message_loading_blue.d83360cf.svg";
export { SvgMessageLoadingBlue as ReactComponent };